import React, { lazy, Suspense, useCallback, useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ToastCustom.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Login fica no bundle inicial para abrir imediatamente.
import Login from './pages/Login';

// Componentes usados apenas depois da autenticação.
const Header = lazy(() => import('./components/Header'));
const MenuLateral = lazy(() => import('./components/MenuLateral'));

// Páginas carregadas sob demanda (code splitting / lazy loading).
const Dashboard = lazy(() => import('./pages/Dashboard'));
const CadastroLead = lazy(() => import('./pages/CadastroLead'));
const ListagemLeads = lazy(() => import('./pages/ListagemLeads'));
const EditarLead = lazy(() => import('./pages/EditarLead'));
const ListagemAcoes = lazy(() => import('./pages/ListagemAcoes'));
const RevisaoObjecoes = lazy(() => import('./pages/RevisaoObjecoes'));
const CriarAcao = lazy(() => import('./pages/CriarAcao'));
const Relatorios = lazy(() => import('./pages/Relatorios'));
const ExportarDados = lazy(() => import('./pages/ExportarDados'));
const Ajuda = lazy(() => import('./pages/Ajuda'));
const RecuperarSenha = lazy(() => import('./pages/RecuperarSenha'));
const RedefinirSenha = lazy(() => import('./pages/RedefinirSenha'));
const EditarAcao = lazy(() => import('./pages/EditarAcao'));
const AlterarSenha = lazy(() => import('./pages/AlterarSenha'));
const EditarMeusDados = lazy(() => import('./pages/EditarMeusDados'));
const GerenciarUsuarios = lazy(() => import('./pages/GerenciarUsuarios'));
const EditarUsuario = lazy(() => import('./pages/EditarUsuario'));
const AdicionarUsuario = lazy(() => import('./pages/AdicionarUsuario'));
const UsuarioConfig = lazy(() => import('./pages/UsuarioConfig'));
const OpiniaoUsuario = lazy(() => import('./pages/OpiniaoUsuario'));
const PoliticaPrivacidade = lazy(() => import('./pages/PoliticaPrivacidade'));
const TermosServico = lazy(() => import('./pages/TermosServico'));
const NoreaCRM = lazy(() => import('./pages/NoreaCRM'));
const NoreaMCPZapi = lazy(() => import('./pages/NoreaMCPZapi'));
const SessoesUsuarios = lazy(() => import('./pages/SessoesUsuarios'));
const SubUsuarios = lazy(() => import('./pages/SubUsuarios'));

const ListarCobrancas = lazy(() => import('./pages/Financeiro/ListarCobrancas'));
const DetalhesCobranca = lazy(() => import('./pages/Financeiro/DetalhesCobranca'));
const CriarCobranca = lazy(() => import('./pages/Financeiro/CriarCobranca'));
const AssociarPagamento = lazy(() => import('./pages/Financeiro/AssociarPagamento'));
const CalculoComissoes = lazy(() => import('./pages/Financeiro/CalculoComissoes'));
const ListarDataCobranca = lazy(() => import('./pages/Financeiro/ListarDataCobranca'));
const PrevisaoRecebimentos = lazy(() => import('./pages/Financeiro/PrevisaoRecebimentos'));
const CriarNotaFiscal = lazy(() => import('./pages/Financeiro/CriarNotaFiscal'));
const NotasFiscais = lazy(() => import('./pages/Financeiro/NotasFiscais'));
const SaldoAsaas = lazy(() => import('./pages/Financeiro/SaldoAsaas'));
const Checkout = lazy(() => import('./pages/Financeiro/Checkout'));
const CheckoutI9 = lazy(() => import('./pages/Financeiro/CheckoutI9'));
const CheckoutImpactus = lazy(() => import('./pages/Financeiro/CheckoutImpactus'));
const Financeiro = lazy(() => import('./pages/FinanceiroNovo/Financeiro'));

// Financeiro dos usuários do CRM (novo módulo).
// Mantido em /gestao-financeira para não colidir com o Financeiro interno do Nórea em /financeiro.
const FinVisaoGeral = lazy(() => import('./pages/FinanceiroUsuario/VisaoGeral'));
const FinMovimentacoes = lazy(() => import('./pages/FinanceiroUsuario/Movimentacoes'));
const FinContas = lazy(() => import('./pages/FinanceiroUsuario/Contas'));
const FinCobrancas = lazy(() => import('./pages/FinanceiroUsuario/Cobrancas'));
const FinConciliacao = lazy(() => import('./pages/FinanceiroUsuario/Conciliacao'));
const FinRelatorios = lazy(() => import('./pages/FinanceiroUsuario/Relatorios'));
const FinCadastros = lazy(() => import('./pages/FinanceiroUsuario/Cadastros'));
const FinIntegracoes = lazy(() => import('./pages/FinanceiroUsuario/Integracoes'));



const IntegrarWhatsApp = lazy(() => import('./pages/WhatsApp/IntegrarWhatsApp'));
const PainelWhatsApp = lazy(() => import('./pages/WhatsApp/PainelWhatsApp'));
const PainelMensagens = lazy(() => import('./pages/WhatsApp/PainelMensagens'));
const PainelMensagensTESTE = lazy(() => import('./pages/WhatsApp/PainelMensagensTESTE'));
const FilaMensagens = lazy(() => import('./pages/WhatsApp/FilaMensagens'));
const PainelInstancias = lazy(() => import('./pages/WhatsApp/PainelInstancias'));
const RespostasRapidas = lazy(() => import('./pages/WhatsApp/RespostasRapidas'));

const GerenciarTags = lazy(() => import('./pages/GerenciarTags'));
const LeadDetalhes = lazy(() => import('./pages/LeadDetalhes'));

const ListarVinculos = lazy(() => import('./pages/Meta/ListarVinculos'));
const VincularContasMeta = lazy(() => import('./pages/Meta/VincularContasMeta'));
const RelatorioMeta = lazy(() => import('./pages/Meta/RelatorioMeta'));
const ResumoFinanceiroMeta = lazy(() => import('./pages/Meta/ResumoFinanceiroMeta'));
const ConfiguracoesMeta = lazy(() => import('./pages/Meta/ConfiguracoesMeta'));

const IARecomendacoesMeta = lazy(() => import('./pages/OpenAi/IARecomendacoesMeta'));
const Biblioteca = lazy(() => import('./pages/OpenAI/Biblioteca'));
const BloqueadosIA = lazy(() => import('./pages/OpenAI/BloqueadosIA'));
const ConfiguracoesIA = lazy(() => import('./pages/OpenAI/ConfiguracoesIA'));
const LogsIA = lazy(() => import('./pages/OpenAI/LogsIA'));
const PainelIA = lazy(() => import('./pages/OpenAI/PainelIA'));
const PendenciasIA = lazy(() => import('./pages/OpenAI/PendenciasIA'));
const PainelFunil = lazy(() => import('./pages/Funil/PainelFunil'));

const IntegracaoGoogleAds = lazy(() => import('./pages/GoogleAds/IntegracaoGoogleAds'));
const RelatorioGoogleAds = lazy(() => import('./pages/GoogleAds/RelatorioGoogleAds'));

const API_BASE = 'https://welaunchyou.com.br/crm-wly';

const PUBLIC_ROUTES = [
  '/login',
  '/recuperar-senha',
  '/redefinir-senha',
  '/checkouti9',
  '/checkout-impactus',
  '/checkout',
  '/politica-privacidade',
  '/termos-de-servico',
  '/norea-crm',
  '/norea-mcp-zapi',
];
const esperar = (ms) => new Promise((resolve) => setTimeout(resolve, ms));


function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [usuarioAtual, setUsuarioAtual] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();

  const limparAutenticacaoLocal = useCallback(() => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('usuario');

    setIsAuthenticated(false);
    setIsAdmin(false);
    setUsuarioAtual(null);
  }, []);

  const aplicarAutenticacao = useCallback((data) => {
    setIsAuthenticated(true);
    setIsAdmin(data.tipo_usuario === 'master');
    setUsuarioAtual(data);

    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem(
      'isAdmin',
      data.tipo_usuario === 'master' ? 'true' : 'false'
    );
    localStorage.setItem('usuario', JSON.stringify(data));
  }, []);

  /**
   * Consulta a sessão no servidor sem derrubar o usuário por falhas transitórias.
   *
   * Retornos:
   * - ativa: sessão confirmada pelo PHP.
   * - invalida: servidor respondeu 401/403 ou informou que não há sessão.
   * - indeterminada: falha de rede/servidor; não deve causar logout automático.
   */
  const consultarSessaoServidor = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE}/checkAuth.php`, {
        credentials: 'include',
        cache: 'no-store',
      });

      if (response.status === 401 || response.status === 403) {
        return {
          estado: 'invalida',
          status: response.status,
        };
      }

      if (!response.ok) {
        return {
          estado: 'indeterminada',
          status: response.status,
        };
      }

      const data = await response.json().catch(() => null);

      if (!data || data.ok !== true) {
        return {
          estado: 'invalida',
          status: response.status,
        };
      }

      return {
        estado: 'ativa',
        status: response.status,
        data,
      };
    } catch (error) {
      console.error('Falha ao consultar sessão:', error);

      return {
        estado: 'indeterminada',
        status: 0,
      };
    }
  }, []);

  /**
   * Faz uma segunda confirmação antes de considerar a sessão inválida.
   * Isso evita logout por uma resposta 401 isolada logo após o login
   * ou durante uma oscilação momentânea.
   */
  const confirmarSessaoServidor = useCallback(async (tentativas = 2) => {
    let resultado = {
      estado: 'indeterminada',
      status: 0,
    };

    for (let tentativa = 0; tentativa < tentativas; tentativa += 1) {
      resultado = await consultarSessaoServidor();

      if (resultado.estado === 'ativa') {
        return resultado;
      }

      if (tentativa < tentativas - 1) {
        await esperar(350 * (tentativa + 1));
      }
    }

    return resultado;
  }, [consultarSessaoServidor]);

  useEffect(() => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'page_view',
    page_path: location.pathname,
    page_title: document.title
  });

}, [location]);

  // Verificação de autenticação
  useEffect(() => {
    let cancelado = false;

    const checkAuth = async () => {
      try {
        const resultado = await confirmarSessaoServidor(2);

        if (cancelado) {
          return;
        }

        if (resultado.estado === 'ativa') {
          aplicarAutenticacao(resultado.data);
          return;
        }

        if (resultado.estado === 'invalida') {
          limparAutenticacaoLocal();
          return;
        }

        /*
         * Se houve falha de rede/servidor, não derruba uma autenticação
         * que já estava estabelecida no navegador. O backend continua
         * protegendo os endpoints normalmente.
         */
        const autenticadoLocal =
          localStorage.getItem('isAuthenticated') === 'true';

        let usuarioLocal = null;

        try {
          usuarioLocal = JSON.parse(localStorage.getItem('usuario'));
        } catch {
          usuarioLocal = null;
        }

        if (autenticadoLocal && usuarioLocal?.id) {
          setIsAuthenticated(true);
          setIsAdmin(
            usuarioLocal.tipo_usuario === 'master' ||
            localStorage.getItem('isAdmin') === 'true'
          );
          setUsuarioAtual(usuarioLocal);
        } else {
          limparAutenticacaoLocal();
        }
      } finally {
        if (!cancelado) {
          setIsLoading(false);
        }
      }
    };

    const pathnameNormalizado =
      location.pathname.replace(/\/+$/, '') || '/';

    if (PUBLIC_ROUTES.includes(pathnameNormalizado)) {
      setIsLoading(false);
      return () => {
        cancelado = true;
      };
    }

    checkAuth();

    return () => {
      cancelado = true;
    };
  }, [
    location.pathname,
    aplicarAutenticacao,
    confirmarSessaoServidor,
    limparAutenticacaoLocal,
  ]);

  // Verificação periódica de atividade no sistema
  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    let encerrado = false;

    const pingSessao = async () => {
      try {
        const response = await fetch(
          `${API_BASE}/sessao_ping.php`,
          {
            method: 'POST',
            credentials: 'include',
            cache: 'no-store',
          }
        );

        const data = await response.json().catch(() => null);

        if (response.status === 401 || response.status === 403) {
          /*
           * Não faz logout por causa de um único 401 do ping.
           * Primeiro confirma a sessão diretamente no checkAuth.php.
           */
          await esperar(350);

          const confirmacao = await confirmarSessaoServidor(2);

          if (encerrado) {
            return;
          }

          if (confirmacao.estado === 'ativa') {
            aplicarAutenticacao(confirmacao.data);
            console.warn(
              'Ping retornou sessão inválida, mas checkAuth confirmou sessão ativa.'
            );
            return;
          }

          if (confirmacao.estado === 'invalida') {
            limparAutenticacaoLocal();
            window.location.replace('/crm-wly/login');
            return;
          }

          /*
           * Em erro de rede/500/etc., mantém o usuário conectado e
           * tenta novamente no próximo ciclo.
           */
          console.warn(
            'Não foi possível confirmar a sessão após falha no ping. ' +
            'O usuário será mantido conectado até nova verificação.'
          );
          return;
        }

        if (!response.ok) {
          console.error(
            'Erro ao atualizar sessão:',
            response.status,
            data
          );
          return;
        }

        console.log('Ping da sessão realizado:', data);
      } catch (error) {
        /*
         * Falha de conexão não é motivo suficiente para encerrar a sessão.
         */
        console.error('Erro de conexão no ping da sessão:', error);
      }
    };

    pingSessao();

    const interval = setInterval(pingSessao, 60000);

    return () => {
      encerrado = true;
      clearInterval(interval);
    };
  }, [
    isAuthenticated,
    aplicarAutenticacao,
    confirmarSessaoServidor,
    limparAutenticacaoLocal,
  ]);

  // Verificação periódica de pendências IA
  useEffect(() => {
    const verificarPendenciasIA = async () => {
      const usuario = JSON.parse(localStorage.getItem('usuario'));
      if (!usuario?.id) return;

      const notificacoesAtivas = localStorage.getItem('notificacoes_pendencias') !== 'off';
      const somAtivo = localStorage.getItem('som_pendencias') !== 'off';

      try {
        const res = await fetch(`${API_BASE}/api/openai/pendencias_ia.php?usuario_id=${usuario.id}`, {
          credentials: 'include',
        });
        const data = await res.json();
        if (data.success && Array.isArray(data.pendencias) && data.pendencias.length > 0 && notificacoesAtivas) {
if (somAtivo) {
  const audio = new Audio("/crm-wly/sounds/alerta.mp3");
  audio.play().catch(() => {});
}
          toast.warning(`⚠️ Você tem ${data.pendencias.length} pendência(s) da IA para assumir.`, { position: "top-right" });
        }
      } catch {}
    };

    if (isAuthenticated) {
      verificarPendenciasIA();
      const intervalo = setInterval(verificarPendenciasIA, 60 * 1000);
      return () => clearInterval(intervalo);
    }
  }, [isAuthenticated]);



  // Regra única de acesso ao novo módulo Financeiro:
  // 1) a conta principal precisa ter o módulo ativo (master sempre tem);
  // 2) se for subusuário, também precisa de menu_financeiro = 1.
  const flagAtiva = (valor) =>
    valor === 1 || valor === '1' || valor === true || valor === 'true';

  const moduloFinanceiroAtivo =
    usuarioAtual?.tipo_usuario === 'master' ||
    flagAtiva(usuarioAtual?.financeiro_ativo);

  const permissaoFinanceiro =
    !flagAtiva(usuarioAtual?.subusuario) ||
    flagAtiva(usuarioAtual?.menu_financeiro);

  const podeAcessarFinanceiro =
    Boolean(usuarioAtual?.id) &&
    moduloFinanceiroAtivo &&
    permissaoFinanceiro;

  const protegerFinanceiro = (elemento) =>
    podeAcessarFinanceiro
      ? elemento
      : <Navigate to="/dashboard" replace />;

  const handleLogout = async () => {
    try {
      const response = await fetch(`${API_BASE}/logout.php`, {
        method: 'POST',
        credentials: 'include'
      });
      if (response.ok) {
        limparAutenticacaoLocal();
        window.location.replace('/crm-wly/login');
      }
    } catch {}
  };

  if (isLoading) return <div>Carregando...</div>;

  return (
    <Suspense fallback={<div>Carregando...</div>}>
      <>
        <div className={`App ${isAuthenticated ? 'has-sidebar' : ''}`} style={{ display: 'flex', height: '100vh' }}>
        {isAuthenticated && (
          <MenuLateral
            key={`${usuarioAtual?.id ?? 'sem-id'}-${usuarioAtual?.financeiro_ativo ?? 0}-${usuarioAtual?.menu_financeiro ?? 0}-${usuarioAtual?.subusuario ?? 0}`}
            isAdmin={isAdmin}
            handleLogout={handleLogout}
          />
        )}

        {/* Este container recebe o margin-left via CSS global */}
        <div className="main-content" style={{ flex: 1, padding: '20px' }}>
          {isAuthenticated && <Header handleLogout={handleLogout} />}

          <Routes>
            {/* POLÍTICA DE PRIVACIDADE: rota pública, acessível com ou sem login */}
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/termos-de-servico" element={<TermosServico />} />

            {!isAuthenticated ? (
              <>
                {/* ROTAS PÚBLICAS */}
                <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} setIsAdmin={setIsAdmin} />} />
                <Route path="/recuperar-senha" element={<RecuperarSenha />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkouti9" element={<CheckoutI9 />} />
                <Route path="/checkout-impactus" element={<CheckoutImpactus />} />
                <Route path="/redefinir-senha" element={<RedefinirSenha />} />
                <Route path="/norea-crm" element={<NoreaCRM />} />
                <Route path="/norea-mcp-zapi" element={<NoreaMCPZapi />} />

                <Route path="*" element={<Navigate to="/login" replace />} />
              </>
            ) : (
              <>
                {/* ROTAS PRIVADAS */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/cadastro-lead" element={<CadastroLead />} />
                <Route path="/editar-lead/:lead_id" element={<EditarLead />} />
                <Route path="/listagem-leads" element={<ListagemLeads />} />
                <Route path="/acoes" element={<ListagemAcoes />} />
                <Route path="/criar-acao/:leadId" element={<CriarAcao />} />
                <Route path="/criar-acao/" element={<CriarAcao />} />
                <Route path="/editar-acao/:acaoId" element={<EditarAcao />} />
                <Route path="/revisao-objecoes" element={<RevisaoObjecoes />} />
                <Route path="/relatorios" element={<Relatorios />} />
                <Route path="/exportacao-dados" element={<ExportarDados />} />
                <Route path="/ajuda-suporte" element={<Ajuda />} />
                <Route path="/alterar-senha" element={<AlterarSenha />} />
                <Route path="/meus-dados" element={<EditarMeusDados />} />
                <Route path="/opiniao" element={<OpiniaoUsuario />} />
                <Route path="/gerenciar-tags" element={<GerenciarTags />} />
                <Route path="/lead-detalhes/:lead_id" element={<LeadDetalhes />} />
                <Route path="/sessoes-usuarios" element={<SessoesUsuarios />} />
                <Route path="/subusuarios" element={<SubUsuarios />} />
                <Route path="/meta/relatorio-meta" element={<RelatorioMeta />} />
                <Route path="/meta/saldo-meta" element={<ResumoFinanceiroMeta />} />
                <Route path="/wzp/integrar-wzp" element={<IntegrarWhatsApp />} />
                <Route path="/wzp/painel-whatsapp" element={<PainelWhatsApp />} />
                <Route path="/wzp/painel-mensagens" element={<PainelMensagens />} />
                <Route path="/wzp/painel-mensagens-teste" element={<PainelMensagensTESTE />} />

                <Route path="/googleads/integracao-googleads" element={<IntegracaoGoogleAds />} />
                <Route path="/googleads/relatorio-googleads" element={<RelatorioGoogleAds />} />


                <Route path="/wzp/fila-mensagens" element={<FilaMensagens />} />
                <Route path="/wzp/respostas-rapidas" element={<RespostasRapidas />} />
                <Route path="/gerenciar-usuarios" element={<GerenciarUsuarios />} />
                <Route path="/adicionar-usuario" element={<AdicionarUsuario />} />
                <Route path="/usuario-config" element={<UsuarioConfig />} />
                <Route path="/editar-usuario/:id" element={<EditarUsuario />} />
                <Route path="/listar-cobrancas" element={<ListarCobrancas />} />

                <Route path="/financeiro" element={<Financeiro />} />

                <Route path="/financeiro/detalhes/:id" element={<DetalhesCobranca />} />
                <Route path="/financeiro/criar-cobranca" element={<CriarCobranca />} />
                <Route path="/financeiro/associar-pagamento" element={<AssociarPagamento />} />
                <Route path="/financeiro/calculo-comissoes" element={<CalculoComissoes />} />
                <Route path="/financeiro/listar-data-cobranca" element={<ListarDataCobranca />} />
                <Route path="/financeiro/previsao-recebimentos" element={<PrevisaoRecebimentos />} />
                <Route path="/financeiro/criar-nota" element={<CriarNotaFiscal />} />
                <Route path="/financeiro/notas" element={<NotasFiscais />} />
                <Route path="/financeiro/saldo-asaas" element={<SaldoAsaas />} />
                <Route path="/meta/listar-vinculos" element={<ListarVinculos />} />
                <Route path="/meta/configuracoes-meta" element={<ConfiguracoesMeta />} />
                <Route path="/meta/vincular-contas-meta" element={<VincularContasMeta />} />
                <Route path="/openai/iarecomendacoes-meta" element={<IARecomendacoesMeta />} />
                <Route path="/wzp/painel-instancias" element={<PainelInstancias />} />
                <Route path="/openai/biblioteca" element={<Biblioteca />} />
                <Route path="/openai/bloqueados" element={<BloqueadosIA />} />
                <Route path="/openai/configuracoes" element={<ConfiguracoesIA />} />
                <Route path="/openai/recomendacoes-meta" element={<IARecomendacoesMeta />} />
                <Route path="/openai/logs" element={<LogsIA />} />
                <Route path="/openai/painel" element={<PainelIA />} />
                <Route path="/openai/pendencias" element={<PendenciasIA />} />
                <Route path="/funil/painel-funil" element={<PainelFunil />} />

                {/* FINANCEIRO DOS USUÁRIOS DO CRM */}
                <Route path="/gestao-financeira" element={protegerFinanceiro(<FinVisaoGeral />)} />
                <Route path="/gestao-financeira/movimentacoes" element={protegerFinanceiro(<FinMovimentacoes />)} />
                <Route path="/gestao-financeira/contas" element={protegerFinanceiro(<FinContas />)} />
                <Route path="/gestao-financeira/cobrancas" element={protegerFinanceiro(<FinCobrancas />)} />
                <Route path="/gestao-financeira/conciliacao" element={protegerFinanceiro(<FinConciliacao />)} />
                <Route path="/gestao-financeira/relatorios" element={protegerFinanceiro(<FinRelatorios />)} />
                <Route path="/gestao-financeira/cadastros" element={protegerFinanceiro(<FinCadastros />)} />
                <Route path="/gestao-financeira/integracoes" element={protegerFinanceiro(<FinIntegracoes />)} />

                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </>
            )}
          </Routes>
        </div>

        <ToastContainer position="top-right" autoClose={8000} hideProgressBar={false} newestOnTop />
        </div>
      </>
    </Suspense>
  );
}

export default function AppWithRouter() {
  // PRE-REDIRECT: aceita links com hash antes do Router montar.
  if (typeof window !== "undefined") {
    const h = window.location.hash;
    if (h && (h.startsWith("#/redefinir-senha") || h.startsWith("#/recuperar-senha"))) {
      const dest = "/crm-wly" + h.slice(1);
      const current = window.location.pathname + window.location.search;
      if (current !== dest) {
        window.location.replace(dest);
        return null;
      }
    }
  }

  return (
    <Router basename="/crm-wly">
      <App />
    </Router>
  );
}
